import { useProductFilter, useSetProductFilter } from '@gripp/shared-logic';
import { useTranslation } from 'react-i18next';
import { EntitySearchInput } from './entitySearchInput';

export const ProductsSearchInput = () => {
  const { t } = useTranslation();
  const { data: filter } = useProductFilter();
  const { mutateAsync } = useSetProductFilter();

  const onSearch = async (keyword: string) => {
    if (!filter) return;
    filter.keyword = keyword;
    await mutateAsync(filter);
  };

  return (
    <EntitySearchInput
      filter={filter}
      onSearch={onSearch}
      placeholder={t('product.filter.searchPlaceholder')}
    />
  );
};
